import { resolveBundledQuizAssetUrl } from './quiz-media';

export function formatSponsorText(names: string[]): string | null {
  const text = names.map((s) => s.trim()).filter(Boolean).join(' · ');
  return text || null;
}

export function hasSponsorLink(sponsorLinkUrl?: string | null): boolean {
  return Boolean(sponsorLinkUrl?.trim());
}

export function shouldShowCampaignSponsorBlock(
  sponsorNames: string[],
  sponsorLinkUrl?: string | null,
): boolean {
  return formatSponsorText(sponsorNames) !== null || hasSponsorLink(sponsorLinkUrl);
}

export function resolveSponsorsPageHref(sponsorLinkUrl?: string | null): string {
  const trimmed = sponsorLinkUrl?.trim();
  return trimmed || '/sponsors';
}

export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}

export function resolveSponsorLogoUrl(value?: string | null): string {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return '';
  return resolveBundledQuizAssetUrl(trimmed);
}
